module.exports = "/_next/static/images/ico_load.ERgMApx3.png";